'use strict';

var AsciiText = require('./util/AsciiText');
var CmdDevice = require('./util/CmdDevice');
var log = require('../../../log/Log').channel('Dell');

function Dell(ipAddress, username, password, onConnectStatus, onControlStatus, config) {
    this.busy = false;
    this.firmwareVersion = 'unknown';
    this.power = false;
    this.videoInput = null;
    this.volume = 0;
    this.volumeMute = false;
    this.pollCycle = 0;

    CmdDevice.call(this, ipAddress, username, password, onConnectStatus,
        onControlStatus, config);
}

Dell.prototype = Object.create(CmdDevice.prototype);

Dell.prototype.constructor = Dell;

Dell.prototype.name = 'Dell';
Dell.prototype.key = '-M23ucYnlfQCx_9ihRue';
Dell.prototype.isBinary = true;
Dell.prototype.isAsync = false;
Dell.prototype.rejectAsync = false;
Dell.prototype.syncTimeoutMs = 1500;
Dell.prototype.pingMs = 5000;
Dell.prototype.pollIntervalMs = 2000;
Dell.prototype.sendTerminator = '';
Dell.prototype.receiveTerminators = [];

Dell.prototype.pollParams = [ '$getInput', '$volumeQuery', '$volumeMuteQuery' ];

Dell.prototype.ports = [{
    port: 4999,
    verifySend: '\x6E\x51\x82\xEB\x20\x76',
    verifyConnection: /\x6F\x6E\x84\x02\x00\x20[\s\S]{2}/,
    verifyTimeoutMs: 3000,
    loginSkip: null,
    loginVerifyTimeoutMs: 0,
    passwordPrompt: null,
    passwordPromptTimeoutMs: 0,
    passwordDefault: null,
    passwordSend: null,
    loginVerify: null,
    loginReject: null,
},{
    port: 4661,
    verifySend: '\x6E\x51\x82\xEB\x20\x76',
    verifyConnection: /\x6F\x6E\x84\x02\x00\x20[\s\S]{2}/,
    verifyTimeoutMs: 3000,
    loginSkip: null,
    loginVerifyTimeoutMs: 0,
    passwordPrompt: null,
    passwordPromptTimeoutMs: 0,
    passwordDefault: null,
    passwordSend: null,
    loginVerify: null,
    loginReject: null,
}];

Dell.prototype.simulationParams = {
    caps: {
        hasPowerControl: true,
        hasRoomVolume: true,
        hasRoomVolumeMute: true,
        hasVideoInputs: true,
        hasVideoSwitcher: true,
        hasFirmwareVersion: true,
    },
    configNotRequired: {
        roomVolume: true,
    },
    firmwareVersion: '2.2',
};

Dell.prototype.commands = {};

Dell.prototype.commands.$getInput = {};
Dell.prototype.commands.$getInput.get = function() {
    if (!this.power) return;  // Only poll while device is powered on
    if (this.hasSync('$getInput')) return;
    if (!this.config.hasOwnProperty('videoInputs')) return;
    this.sendCommand('$getInput',
        this.makeCommand([ 0x6E, 0x51, 0x82, 0xEB, 0x62 ]));
};
Dell.prototype.commands.$getInput.match = /\x6F\x6E\x87\x02\x00\x62\x00\x00\x00([\s\S])[\s\S]/;
Dell.prototype.commands.$getInput.process = function(match) {
    this.updateVideoInput(parseInt(match[1].charCodeAt(0),10).toString());
};

Dell.prototype.commands.$volumeQuery = {};
Dell.prototype.commands.$volumeQuery.get = function() {
    if (!this.power) return;  // Only poll while device is powered on
    if (this.hasSync('$volumeQuery')) return;
    this.sendCommand('$volumeQuery', this.makeCommand([ 0x6E, 0x51, 0x82, 0xEB, 0xB0 ]));
};
Dell.prototype.commands.$volumeQuery.match = /\x6F\x6E\x84\x02\x00\xB0([\s\S])[\s\S]/;
Dell.prototype.commands.$volumeQuery.process = function(match) {
    // Convert Dell volume range (0 - 100) to system (0 - 50)

    var newVolume = Math.round(parseInt(match[1].charCodeAt(0), 10) * 50 / 100);

    if (this.volume !== newVolume) {
        this.volume = newVolume;
        this.broadcastStatus('volume', this.volume);
        this.set('volumeMute', this.volume === 0);
    }
};

Dell.prototype.commands.$volumeMuteQuery = {};
Dell.prototype.commands.$volumeMuteQuery.get = function() {
    if (!this.power) return;  // Only poll while device is powered on
    if (this.hasSync('$volumeMuteQuery')) return;
    this.sendCommand('$volumeMuteQuery', this.makeCommand([ 0x6E, 0x51, 0x82, 0xEB, 0xB1 ]));
};
Dell.prototype.commands.$volumeMuteQuery.match = /\x6F\x6E\x84\x02\x00\xB1([\s\S])[\s\S]/;
Dell.prototype.commands.$volumeMuteQuery.process = function(match) {
    var newVolumeMute = match[1] === '\x01' ? true : false;

    if (this.volumeMute !== newVolumeMute) {
        this.volumeMute = newVolumeMute;
        this.broadcastStatus('volumeMute', this.volumeMute);
    }
};

Dell.prototype.commands.busy = {};
Dell.prototype.commands.busy.get = function() {
    this.broadcastStatus('busy', this.busy);
};

Dell.prototype.extractCommand = function(buffer) {
    // The Dell API doesn't have terminators on its commands or responses,
    // and the commands are not well suited for matching with the
    // unterminatedRegExp method; so we provide this command extraction
    // function.
    //
    // Command Format: [Header2] [Header3] [Len+0x80] [ReplyCode] [Cmd] [Data0]...[DataN] [checksum]

    // Len is the number of bytes from [ReplyCode] to [DataN]

    // Try each byte in the buffer as a starting position, in case we got some
    // line noise.

    for (var i = 0; i < buffer.length - 5; i++) {
        // Make sure all the bytes for this command are present.

        if (buffer.charCodeAt(i) === 0x6F && buffer.charCodeAt(i + 1) === 0x6E) {
            // All responses from the Dell display start with 0x6F and 0x6E
            // Compute the checksum - XOR of all bytes except checksum byte

            var cmdLen = buffer.charCodeAt(2) - 0x80;
            var checksum = 0x50; // From Dell documentation

            for (var j = i; j < i + cmdLen + 2; j++) {
                checksum ^= buffer.charCodeAt(j);
            }

            // If the checksum is correct, return the command and the updated
            // buffer.

            if (checksum === buffer.charCodeAt(i + cmdLen + 3)) {
                var cmd = buffer.slice(i, i + cmdLen + 4);
                buffer = buffer.slice(i + cmdLen + 4);
                return [cmd, buffer];
            }
        }
    }

    return null;
};

Dell.prototype.commands.firmwareVersion = {};
Dell.prototype.commands.firmwareVersion.get = function() {
    if (this.hasSync('firmwareVersion')) return;
    this.sendCommand('firmwareVersion',
        this.makeCommand([ 0x6E, 0x51, 0x82, 0xEB, 0xA0 ]));
};
Dell.prototype.commands.firmwareVersion.match = /\x6F\x6E[\s\S]\x02\x00\xA0([\s\S]+)[\s\S]/;
Dell.prototype.commands.firmwareVersion.process = function (match) {
    this.broadcastStatus('firmwareVersion', match[1]);
};

Dell.prototype.commands.ping = {};
Dell.prototype.commands.ping.activeStates = [ 'controlling', 'controlFailed' ];
Dell.prototype.commands.ping.get = function() {
    this.sendCommand('ping',
        this.makeCommand([ 0x6E, 0x51, 0x82, 0xEB, 0x20 ]));
};
Dell.prototype.commands.ping.match = /\x6F\x6E\x84\x02\x00\x20([\s\S])[\s\S]/;
Dell.prototype.commands.ping.process = function(match) {
    var newPower = match[1] === '\x01' ? true : false;

    if (this.power !== newPower) {
        this.power = newPower;
        this.broadcastStatus('power', this.power);
    }
};

Dell.prototype.commands.power = {};
Dell.prototype.commands.power.get = function() {
    this.broadcastStatus('power', this.power);
};
Dell.prototype.commands.power.set = function(value) {
    this.power = value;
    this.broadcastStatus('power', this.power);
    this.removePollCommands();
    this.cmdSocket.removeSync('power');
    this.sendCommand('power',
        this.makeCommand([ 0x6E, 0x51, 0x83, 0xEA, 0x20, value ? 0x01 : 0x00 ]));
    this.setBusy(true, 0);
    this.setBusy(false, this.power ? 10000 : 10000);
};
Dell.prototype.commands.power.match = /\x6F\x6E\x83\x02\x00\x20\xD0/;

Dell.prototype.commands.videoInput = {};
Dell.prototype.commands.videoInput.get = function() {
    if (!this.config.hasOwnProperty('videoInputs')) {
        log.error(this + ': videoInput: get: no videoInputs in config: ' +
            JSON.stringify(this.config, null, 4));
        return;
    }

    this.broadcastStatus('videoInput', this.videoInput);
};
Dell.prototype.commands.videoInput.set = function(srcId) {
    if (!this.config.hasOwnProperty('videoInputs')) {
        log.error(this + ': videoInput: set: no videoInputs in config: ' +
            JSON.stringify(this.config, null, 4));
        return;
    }

    if (!this.config.videoInputs.hasOwnProperty(srcId)) {
        log.error(this + ': videoInput: set: srcId = ' + srcId +
            ' not present in videoInputs for config = ' +
            JSON.stringify(this.config, null, 4));
    }

    this.removePollCommands();
    var code = parseInt(this.config.videoInputs[srcId].code,10);
    this.cmdSocket.removeSync('videoInput');
    this.sendCommand('videoInput',
        this.makeCommand([ 0x6E, 0x51, 0x86, 0xEA, 0x62, 0x00, 0x00, 0x00, code ]));

    if (this.videoInput !== srcId) {
        this.videoInput = srcId;
        this.broadcastStatus('videoInput', this.videoInput);
        this.setBusy(true, 0);
        this.setBusy(false, 4000);
    }
};
Dell.prototype.commands.videoInput.match = /\x6F\x6E\x83\x02\x00\x62[\s\S]/;

Dell.prototype.commands.volume = {};
Dell.prototype.commands.volume.get = function() {
    this.broadcastStatus('volume', this.volume);
};
Dell.prototype.commands.volume.set = function(value) {
    // Convert Mira Connect volume range (0 - 50) to Dell volume range (0 - 100)

    var scaledValue = Math.round(100 * value / 50);
    this.cmdSocket.removeSync('volume');
    this.sendCommand('volume', this.makeCommand([ 0x6E, 0x51, 0x83, 0xEA, 0xB0, scaledValue ]));
    this.volume = value;
    this.broadcastStatus('volume', this.volume);
    this.set('volumeMute', value === 0);
};
Dell.prototype.commands.volume.match = /\x6F\x6E\x83\x02\x00\xB0[\s\S]/;

Dell.prototype.commands.volumeMute = {};
Dell.prototype.commands.volumeMute.get = function() {
    this.broadcastStatus('volumeMute', this.volumeMute);
};
Dell.prototype.commands.volumeMute.set = function(value) {
    this.cmdSocket.removeSync('volumeMute');
    this.sendCommand('volumeMute',
        this.makeCommand([ 0x6E, 0x51, 0x83, 0xEA, 0xB1, value ? 0x01 : 0x00 ]));
    this.volumeMute = value;
    this.broadcastStatus('volumeMute', this.volumeMute);
};
Dell.prototype.commands.volumeMute.match = /\x6F\x6E\x83\x02\x00[\s\S]/;

Dell.prototype.getVideoInputFromCode = function(code) {
    for (var srcId in this.config.videoInputs) {
        if (!this.config.videoInputs.hasOwnProperty(srcId)) continue;

        if (code === this.config.videoInputs[srcId].code) {
            return srcId;
        }
    }

    log.warning(this + ': unmatched video input code: ' + code);

    return null;
};

// Commands are [H0] [H1] [Len+0x80] [R/W] [Cmd] [Data0] ... [DataN]
// Checksum is [H0] xor [H1] xor [Len] xor [R/W] xor [Data0] xor ... xor [DataN]
Dell.prototype.makeCommand = function(data) {
    var bytes = [];
    var checksum = 0;
    var payloadLen = data[2] - 0x80;

    bytes = bytes.concat(data);

    // Compute the checksum.

    for (var i = 0; i < payloadLen+3; i++) {
        checksum ^= bytes[i];
    }

    bytes.push(checksum); // Add the checksum to the command.

    return AsciiText.decode(bytes);
};

Dell.prototype.onComputeCaps = function() {
    var caps = this.getCapsTemplate();
    caps.hasPowerControl = true;
    caps.hasVideoSwitcher = true;
    this.computeCapsFromConfig(caps);
    caps.hasRoomVolume = true;
    caps.hasRoomVolumeMute = true;
    caps.hasBusy = true;
    caps.hasFirmwareVersion = true;

    return caps;
};

Dell.prototype.onPoll = function() {
    if (this.pollCycle < 0 || this.pollCycle >= this.pollParams.length) {
        this.pollCycle = 0;
    }

    this.query(this.pollParams[this.pollCycle]);
    this.pollCycle++;
};

Dell.prototype.removePollCommands = function() {
    for (var i = 0; i < this.pollParams.length; i++) {
        this.cmdSocket.removeSync(this.pollParams[i]);
    }
};

Dell.prototype.updateVideoInput = function(code) {
    var foundId = this.getVideoInputFromCode(code);

    if (this.videoInput !== foundId) {
        this.videoInput = foundId;
        this.broadcastStatus('videoInput', this.videoInput);
    }
};

module.exports = Dell;
